<script setup lang="ts">
/**
 * The Smake logo: the mark in Smake green (#93D500) and the "Smake" wordmark
 * in the foreground colour, so it reads in light and dark mode. Assets in
 * src/assets (from the Smake app's brand files, optimised with SVGO).
 */
import mark from "@/assets/smake-mark.svg?raw";
import wordmark from "@/assets/smake-wordmark.svg?raw";
import { t } from "@/copy/strings";

defineProps<{ compact?: boolean }>();
</script>

<template>
  <span class="brand-mark inline-flex items-center gap-2" role="img" :aria-label="t.app.name">
    <!-- Static, trusted SVG files from src/assets. -->
    <span class="brand-glyph h-7 shrink-0" aria-hidden="true" v-html="mark" />
    <span v-if="!compact" class="brand-glyph h-[17px] shrink-0 text-foreground" aria-hidden="true" v-html="wordmark" />
  </span>
</template>

<style scoped>
.brand-glyph {
  display: inline-flex;
}
.brand-glyph :deep(svg) {
  height: 100%;
  width: auto;
}
</style>
